export function normalizeWell(well) {
  if (!well) return null;
  // Handle both plain objects and Mongoose-style objects
  const rawId = well._id || well.id;
  const id = rawId ? rawId.toString() : null;
  if (!id || id === "undefined") return { ...well, id: null };
  return {
    ...well,
    id,
    _id: id,
  };
}

export function normalizeWells(wells) {
  return wells.map(normalizeWell);
}
